export enum SCALE_LOGIC {
  FROM_MIN = 'fromMin',
  FROM_ZERO = 'fromZero',
}
